export default "__VITE_ASSET__C_xxpIGG__"